import React, { useEffect, useState, useContext } from "react";
import EmpresaContext from "../../../../contexts/Empresa";
import api from "../../../../services/api";
import moment from "moment";
import "moment/locale/pt-br";

import Pagination from "../../../../components/Pagination";
import { Button, Modal, ListGroupItem, ListGroup, Spinner } from "reactstrap";

moment.locale("pt-br");

export default ({ show, historicos, oportunidade_id, notify, onHidde }) => {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageProperties, setPageProperties] = useState({
    page: 1,
    lastPage: 1,
  });

  useEffect(() => {
    if (show) loadHistorico(pageProperties);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  async function loadHistorico({ page = 1, limit = 10 }) {
    try {
      setLoading(true);
      const response = await api.get(
        `/common/empresas/${empresaSelecionada.id}/oportunidades/${oportunidade_id}/historicos`,
        {
          params: {
            page,
            limit,
          },
        }
      );

      const array = response.data.data;
      setItens(array);
      setPageProperties(response.data);
    } catch (error) {
      console.error(error);
      notify("danger", "Não foi possível carregar histórico");
    } finally {
      setLoading(false);
    }
  }

  const createHistoricoPreview = (item, key) => {
    const dataFormatada = moment(
      item.data_evento,
      "DD-MM-YYYY HH:mm:ss"
    ).format("LLL");

    return (
      <ListGroupItem
        key={key}
        className="list-group-item-action flex-column align-items-start  border-0 py-0"
      >
        <div className="d-flex">
          {/* bolinha / ícone da timeline */}
          <div className="d-flex flex-column align-items-center mr-3">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: 36,
                height: 36,
                border: "1px solid #dee2e6",
              }}
            >
              {/* ícone vindo do backend */}
              <i className={`fas ${item.icone}`}></i>
            </div>
            {/* linha vertical da timeline */}
            <div
              style={{
                flex: 1,
                width: 2,
                backgroundColor: "#e9ecef",
                marginTop: 4,
              }}
            />
          </div>

          {/* conteúdo do evento */}
          <div className="flex-fill">
            <div className="d-flex flex-column w-100 justify-content-between  mb-1">
              <div>
                <h5 className="mb-0 fw-bold">{item.evento.toUpperCase()}</h5>
              </div>
              <div>
                <small className="text-orange">{dataFormatada}</small>
              </div>
            </div>

            <p className="text-sm mb-4 mt-2">{item.texto_evento}</p>
          </div>
        </div>
      </ListGroupItem>
    );
  };

  return (
    <>
      <Modal
        className="modal-dialog-centered modal-lg"
        isOpen={show}
        toggle={onHidde}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Histórico
          </h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={onHidde}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <ListGroup flush className="py-4 px-4">
                {itens.map((item, key) => createHistoricoPreview(item, key))}
              </ListGroup>

              <Pagination
                pageProperties={pageProperties}
                load={(pageProps) => loadHistorico(pageProps)}
              />
            </>
          )}
        </div>

        <div className="modal-footer p-0">
          <Button
            color="link"
            data-dismiss="modal"
            type="button"
            onClick={onHidde}
          >
            Fechar
          </Button>
        </div>
      </Modal>
    </>
  );
};
